<div class="container my-4">
  <div class="row">
    <div class="col-12 ">
      <span class="title_header_bar">Manage Action</span>
    </div>
  </div>
  <div class="card card_content">
    <div class="row d-flex justify-content-between align-items-center">
      <div class="col-md-3 d-flex  align-items-center">
        <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
          <i class="fa fa-refresh"></i> Refresh
        </button> -->
        <app-button (refreshClicked)="clearFilter()"></app-button>

        <button type="button" class="btn excel_btn text-nowrap mr-2" (click)="exportAsXLSX()">
          <i class="fa fa-file-excel"></i> Export
        </button>
      </div>
      <div class="col-2">
        <button type="button" class="btn btn-primary  d-flex" (click)="filterOpen = !filterOpen">
          <ng-container *ngIf="!filterOpen">
            <app-icon name="arrow-rounded-down-12x7" size="12x7"></app-icon>
          </ng-container>
          <ng-container *ngIf="filterOpen">
            <app-icon name="arrow-rounded-up-13x8" size="13x8"></app-icon>
          </ng-container>
          <span class="ml-2">Filters</span>
        </button>
      </div>
    </div>
    <div [@detailExpand]="filterOpen ? 'expanded' : 'collapsed'" style="overflow: hidden;">
      <hr>
      <div class="container my-4">
        <form [formGroup]="form">
          <div class="subtitle_header">Filterd By</div>

            <div class="row mx-5">
              <div class="col-xl-6 mt-4">
                <mat-form-field appearance="fill" hideRequiredMarker>
                  <mat-label>Responsible person</mat-label>
                  <mat-select class="scrollbarcs" formControlName="personResponsible_Id"
                    (selectionChange)="onSelectChange($event)" placeholder="Select Responsible person ">
                    <mat-select-filter [displayMember]="'value'" [array]="userList"
                      (filteredReturn)="filteredList = $event"></mat-select-filter>
                    <mat-option [value]="'user'">Responsible person</mat-option>
                    <mat-option *ngFor="let item of filteredList" [value]="item.key"
                      style="overflow-y: scroll !important;">
                      {{item.value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-xl-6 mt-4">
                <mat-form-field appearance="fill" hideRequiredMarker>
                  <mat-label>Activity Number</mat-label>
                  <mat-select class="scrollbarcs" formControlName="activityNumber"
                    (selectionChange)="onSelectChange($event)" placeholder="Select Responsible person ">
                    <mat-select-filter [displayMember]="'value'" [array]="activitynumber"
                      (filteredReturn)="filteredList1 = $event"></mat-select-filter>
                    <mat-option [value]="'Activityno'">Activity Number</mat-option>
                    <mat-option *ngFor="let item of filteredList1" [value]="item.key"
                      style="overflow-y: scroll !important;">
                      {{item.value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row mx-5">
              <div class="col-xl-6 mt-4">
                <mat-form-field appearance="fill" hideRequiredMarker>
                  <mat-label>Status</mat-label>
                  <mat-select class="scrollbarcs" formControlName="actionStatus"
                    (selectionChange)="onSelectChange($event)" placeholder="Select Responsible person ">
                    <mat-select-filter [displayMember]="'value'" [array]="status"
                      (filteredReturn)="status = $event"></mat-select-filter>
                    <mat-option [value]="'status'">Status</mat-option>
                    <mat-option *ngFor="let item of status" [value]="item.key" style="overflow-y: scroll !important;">
                      {{item.value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="d-flex justify-content-end button-style mt-3 mr-3">
              <button class="btn reset_btn mb-3 mr-3" type="button" (click)="clearFilter()" matButton><i class="fa fa-refresh"></i> Reset</button>
              <button class="btn btn-secondary mb-3 mr-5" type="submit" (click)="filter()" matButton><i class="fa fa-search"></i> Search</button>
            </div>
          </form>
      </div>
    </div>

    <div class="table-responsive mt-2 mb-4">
      <mat-table #table [dataSource]="dataSource">

        <ng-container matColumnDef="ActivityNo">
          <mat-header-cell *matHeaderCellDef>Activity No</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <p class="text-truncate txtalign" style="cursor: pointer; color:#9B02DB;"
              (click)="view(dataField.applicationActivityId)"> <b>{{dataField.activityNo}}</b></p>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ApplicationNo">
          <mat-header-cell *matHeaderCellDef>Application No</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <p class="text-truncate txtalign">{{dataField.applicationNumber}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="ActivityType">
          <mat-header-cell *matHeaderCellDef> Activity Type</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <p class="text-truncate txtalign">{{dataField.activityType}} </p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TargetDate">
          <mat-header-cell *matHeaderCellDef>Target Date</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <p class="text-truncate txtalign">{{dataField.targetDate}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="PersonResponsible">
          <mat-header-cell *matHeaderCellDef>Person Responsible</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <p class="text-truncate txtalign">{{dataField.personResponsible}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Comments">
          <mat-header-cell *matHeaderCellDef>Comments</mat-header-cell>
          <mat-cell *matCellDef="let dataField" style="width: 25%;">
            <p class="text-truncate txtalign">{{dataField.comments}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let dataField" style="width: 10%;">
            <p class="text-truncate txtalign">{{dataField.status}}</p>
          </mat-cell>
        </ng-container>




        <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

        <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
        </mat-row>


      </mat-table>
      <div *ngIf="dataSource.filteredData.length === 0" class="no-data-message">
        <p>No data found</p>
      </div>
    </div>


    <div class="table_pagenation">
      <mat-paginator #paginator [length]="dataSource!==null && dataSource.filteredData.length" [pageIndex]="0"
        [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
      </mat-paginator>
    </div>
  </div>
</div>